import React, { useState, useRef, useEffect } from "react";
import { AppProperties } from "../common/functions";
import {
    Card,
    CardTitle,
    CardActions,
    CardText,
    TextField,
    Button,
    FontIcon,
} from "react-md";
import logo from "../images/png/SF-Logo.png";
import QMlogo from "../images/png/EQM.png";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { BeatLoader } from "react-spinners";

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100vh",
        padding: "1em",
    },
    loginPanel: {
        maxWidth: "25%",
        minWidth: "350px",
    },
    univName: {
        fontSize: "3rem",
        textAlign: "center",
        fontWeight: "bold",
        margin: "0rem",
        padding: "1.5rem 0rem",
    },
    imageContainer: {
        padding: "0.5em",
    },
    image: {
        maxWidth: "100%",
    },
    underline: { textDecoration: "underline" },
};

function RequestCodeForm(props) {
    const history = useHistory();
    const appProperties = AppProperties();

    const emailRef = useRef(null);
    const [emailError, setEmailError] = useState(false);
    const mailDomains = appProperties.mailDomain.split(";");
    const {whitelist} = props;
    const mailIDError = `Enter a valid ${mailDomains.length > 1 ? mailDomains.join(" or ") : mailDomains
        } id`;

    const [loading, setLoading] = useState(false);

    const clearAllNotifications = () => {
        NotificationManager.listNotify.forEach(n => {
            NotificationManager.remove({ id: n.id })
        });
    }

    useEffect(() => {
        clearAllNotifications();
        setLoading(false)
    }, [])

    const isValid = () => {
        setEmailError(false);
        // check if email is valid
        if (emailRef.current.value.length <= 0) {
            emailRef.current.focus();
            setEmailError(true);
            return false;
        } else {
            let domainName = emailRef.current.value.toLowerCase().split("@");
            //let domainName =  emailRegex.exec((emailRef.current.value).toLowerCase());

            if (
                !(domainName.length > 1) ||
                !(domainName[0].trim().length > 1) ||
                ((!domainName || !mailDomains.includes(domainName[1])) &&
                    !whitelist.includes(emailRef.current.value.toLowerCase()))
            ) {
                emailRef.current.focus();
                setEmailError(true);
                return false;
            }
        }

        return true;
    };

    const handleSubmit = () => {
        setLoading(true)
        console.debug("isValid", isValid())

        if (isValid()) {
            const emailID = emailRef.current.value;
            const response = props.apiService({
                method: 'post',
                skipErrorHandle: false,
                url: '/sendCode',
                data: {
                    emailID,
                }
            });

            response.then(res => {
                if (res && res.data.status === 0) {
                    NotificationManager.success("A verification code should be sent to your email address. Please check in spam and quarantine folders too", "Success", 6000)
                    setTimeout(() => {
                        history.push('/activation-code')
                    }, 6000)
                } else {
                    NotificationManager.error(res.data.message, "ERROR", 4000)
                }
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    };


    return (
        <div style={styles.container}>
            <Card style={styles.loginPanel}>
                <div className="bg-color-primary" style={styles.imageContainer}>
                    {appProperties.eqmMode ? (
                        <img
                            style={styles.image}
                            alt="EQM"
                            title="EQuizMaster"
                            src={QMlogo}
                        />
                    ) : (
                        <>
                            <img
                                style={styles.image}
                                alt="Stem Fluency"
                                title="Stem Fluency"
                                src={logo}
                            />
                        </>
                    )}
                </div>

                {loading ? <BeatLoader color='#bb0000' loading={true} size={10} /> :
                    <div>
                        <CardTitle subtitle='Request Activation Code'></CardTitle>
                        <CardText>
                                <TextField
                                    autoComplete="email"
                                    id="email"
                                    inputStyle={{
                                        fontSize: "1rem",
                                    }}
                                    className="px-2 pb-4"
                                    ref={emailRef}
                                    errorText={emailError ? mailIDError : ""}
                                    error={emailError}
                                    // label="Email ID"
                                    required
                                    leftIcon={<FontIcon className="m-0">email</FontIcon>}
                                    placeholder="Enter your university email address"
                                ></TextField>
                        </CardText>

                        <CardActions>
                            <Button
                                style={styles.underline}
                                className="md-cell--left"
                                flat
                                primary
                                onClick={() => {
                                    history.push("/");
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="md-cell--right"
                                primary
                                raised
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                Submit
                            </Button>
                        </CardActions>
                    </div>
                }
            </Card>
            <NotificationContainer />
        </div>
    );
}

export default RequestCodeForm;
